module.exports = __webpack_public_path__ + "img/Menu.5bb971ce.png";